export function formatDate(timestamp) {
    if (!timestamp || !timestamp._seconds) return 'Invalid Date';

    const date = new Date(timestamp._seconds * 1000); // Convert seconds to milliseconds
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
    console.log("dsa", options)
    let formatted=new Intl.DateTimeFormat('en-US', options).format(date);
    console.log("formatted", formatted)
    return formatted
}
